import { NgModule } from '@angular/core';

import { QuillEditorComponent } from './quill-editor.component';

@NgModule({
  declarations: [
    QuillEditorComponent
  ],
  imports: [],
  exports: [QuillEditorComponent],
  providers: []
})
export class QuillModule { }



// WEBPACK FOOTER //
// ./~/ngx-quill/src/quill.module.ts